const QuizGeneralUI = {
  init() {
    this.initializeCarousel();
    this.initializeFAQ();
    this.bindCommonEvents();
  },

  initializeCarousel() {
    $('.qz_revs_carousel:not(.slick-initialized)').slick({
      dots: true,
      infinite: true,
      slidesToShow: 3,
      arrows: true,
      responsive: [
        {
          breakpoint: 678,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '30px'
          }
        }
      ]
    });

    $('.qz_rn_next').click(function () {
      $('.qz_revs_carousel').find('.slick-next').trigger('click');
    });

    $('.qz_rn_prev').click(function () {
      $('.qz_revs_carousel').find('.slick-prev').trigger('click');
    });

    // Initialize reviews carousel if it exists
    if ($('.qz_reviews_carousel').length) {
      $('.qz_reviews_carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '60px',
        dots: false,
        arrows: false,
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            dots: false,
            arrows: true,
            centerPadding: '20px'
          }
        }]
      });
    }
  },

  initializeFAQ() {
    $('.Science_cell_header__js').click(function () {
      $(this).toggleClass('active');
      $(this).find('.Offer_science_cell_text').slideToggle();
    });

    $('.Offer_faq_tab').click(function () {
      $(this).toggleClass('active');
      $(this).find('.Offer_faq_answer').slideToggle();
    });

    $('.Offer_main_faq_cell').click(function () {
      if ($(this).hasClass('active')) {
        $(this).toggleClass('active');
        $(this).find('.Faq_thumb').slideToggle();
      } else {
        $(this).toggleClass('active');
        $('.Faq_thumb').slideUp();
        $(this).find('.Faq_thumb').slideToggle();
      }
    });
  },

  bindCommonEvents() {
    // Show results button
    $('.qz_start_btn.button.qz_show_results').click(function (evt) {
      evt.preventDefault();
      console.log('clicked');
      QuizUtils.scrollToSection(".qz_results_grid");
    });

    // Header scroll button
    $('.Header_scroll_js').click(function () {
      const window_url = String(window.location);
      if (window_url.includes('main-3') || window_url.includes('sale-offer')) {
        QuizUtils.scrollToSection(".Offer__section__js", -100);
      }
    });
  }
};

// Utility functions for quiz
const QuizUtils = {
  scrollToSection(selector, offset = 0) {
    $('html, body').animate({
      scrollTop: $(selector).offset().top + offset
    }, 500);
  },

  getRandomArbitrary(min, max) {
    return Math.round(Math.random() * (max - min) + min);
  }
};

$(document).ready(function () {
  QuizGeneralUI.init();
});